module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C126",
    attrs: {
      "id": "page_IX"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "C127"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0006#page_i"
    }
  }, [_vm._v("Foreword to "), _c('em', [_vm._v("The Cullen Collection")])])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0007#page_vi"
    }
  }, [_vm._v("Introduction to "), _c('em', [_vm._v("The Princess and Curdie")])])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0012#page_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. The Mountain")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0013#page_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The White Pigeon")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0014#page_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The Mistress of the Silver Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0015#page_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Curdie’s Father and Mother")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0016#page_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The Miners")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0017#page_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The Emerald")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0018#page_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. What "), _c('em', [_vm._v("is")]), _vm._v(" in a Name?")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0019#page_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Curdie’s Mission")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0020#page_58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Hands")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0021#page_62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. The Heath")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0022#page_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Lina")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0023#page_70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. More Creatures")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0024#page_73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. The Baker’s Wife")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0025#page_79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. The Dogs of Gwyntystorm")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0026#page_84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Derba and Barbara")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0027#page_89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. The Mattock")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0028#page_95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. The Wine Cellar")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0029#page_100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. The King’s Kitchen")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0030#page_104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. The King’s Chamber")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0031#page_112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. Counter-plotting")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0032#page_118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. The Loaf")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0033#page_122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. The Lord Chamberlain")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0034#page_128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. Dr. Kelman")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0035#page_134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24. The Prophecy")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0036#page_141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25. The Avengers")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0037#page_146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26. The Vengeance")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0038#page_152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27. More Vengeance")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0039#page_157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28. The Preacher")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0040#page_162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29. Barbara")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0041#page_165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30. Peter")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0042#page_167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31. The Sacrifice")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0043#page_171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32. The King’s Army")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0044#page_176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33. The Battle")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0045#page_180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34. Judgement")])]), _vm._v(" "), _c('p', {
    staticClass: "C129"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0046#page_184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35. The End")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e94be12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part0004.vue
// module id = 72
// module chunks = 0